import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=067663c1&scoped=true"
import script from "./AddFriend.vue?vue&type=script&lang=js"
export * from "./AddFriend.vue?vue&type=script&lang=js"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=067663c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067663c1",
  null
  
)

export default component.exports